import SquaredLinkComponent from './SquaredLinkComponent'
export * from './SquaredLinkComponent'
export default SquaredLinkComponent
